<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2">
                    فیلتر داده‌ها
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.from_number.val" size="sm" dir="ltr" disabled />
                                    <CButton @click="modal=true" size="sm" color="info" block>انتخاب شماره</CButton>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.to_num.val" :description="form.to_num.inv" dir="ltr" label="به شماره" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.sms_text.val" :description="form.sms_text.inv" label="پیام" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <label>تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.created_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at.inv}}</small>
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get();" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" class="ml" color="danger">حذف فیلتر</CButton>
                                <CButton @click="download_modal=true" v-show="$store.state.perms.can_user_download_message_in_csv_format"
                                    color="primary">دانلود گزارش با فرمت CSV</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>گزارش دریافت</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #user_name="data">
                                <td>
                                    <router-link :to="`/profile/${data.item.user_id}`">{{data.item.user_name}}</router-link>
                                </td>
                            </template>
                            <template #short_sms_text="data">
                                <td>
                                    <CButton @click="sms_text_modal=true;sms_text=data.item.full_sms_text"
                                    color="link">{{data.item.short_sms_text}}</CButton> 
                                </td>
                            </template>
                            <template #action="data">
                            <td>
                                <template>
                                <div class="flex-container">
                                    <div @click="open_to(`/message/${data.item.id}/inbox`)"
                                        v-c-tooltip.hover="'جزییات'">
                                        <CIcon name="cilListRich" size="lg"/>
                                    </div>
                                </div>
                                </template>
                            </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="دقت کنید"
            size="sm"
            color="primary"
            :show.sync="download_modal"
            >
            <p>آیا برای دانلود گزارش با فرمت CSV اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="download_modal=false" color="secondary">خیر</CButton>
            <CButton @click="validator();download()" color="primary">بله</CButton>
            </template>
        </CModal>
        <CModal
            title="متن کامل پیام"
            size="sm"
            color="primary"
            :show.sync="sms_text_modal"
            >
            <p v-html="sms_text"></p>
            <template #footer>
                <CButton @click="sms_text_modal=false" color="primary">بستن</CButton>
            </template>
        </CModal>
        <CModal
            title="انتخاب شماره"
            size="sm"
            color="info"
            :show.sync="modal"
            >
            <CRow>
                <CCol sm="12">
                    <CInput v-model="number_like" @keyup.enter="get_numbers()" dir="ltr" label="جستجو در شماره‌ها"/>
                    <small>راهنما: برای جستجو در شماره‌ها چند رقم از شماره مورد نظر را وارد کرده و سپس دکمه Enter را فشار دهید. پس از نمایش پیغام پایان جستجو، شماره مورد نظر را از زیر انتخاب کنید.</small>
                </CCol>
                <CCol sm="12">
                    <br/>
                    <label>انتخاب شماره</label>
                    <model-select :options="numbers" v-model="from_selected" placeholder="انتخاب کنید">
                    </model-select>
                    <small class="form-text text-muted w-100">{{form.from_number.inv}}</small>
                </CCol>
            </CRow>
            <template #footer>
                <CButton @click="form.from_number.val=from_selected;modal=false;" color="primary">تایید</CButton>
                <CButton @click="modal=false" color="secondary">بستن</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'user_name', label: 'کاربر' },
                { key: 'from_number', label: 'از شماره' },
                { key: 'to_number', label: 'به شماره' },
                { key: 'short_sms_text', label: 'پیام' },
                { key: 'created_at', label: 'تاریخ ایجاد' },
                { key: 'action', label: 'عملیات' },
            ],
            collapse: false,
            form: {
                user_id: { val: '', inv: '', v: { max: 8 } },
                from_number: { val: '', inv: '', v: { max: 16 } },
                to_num: { val: '', inv: '', v: { max: 16 } },
                sms_text: { val: '', inv: '', v: { max: 256 } },
                created_at: { val: '', inv: '', v: { max: 16 } },
            },
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            sms_text: '',
            sms_text_modal: false,
            download_modal: false,
            users: [],
            modal: false,
            number_like: '',
            numbers: [],
            from_selected: '',
        }
    },
    watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        },
    },
    mounted(){
        this.get();
        this.get_users();
    },
    methods: {
        get_numbers() {
            this.axios.get('user_nums/'
                + '?number_like=' + this.number_like)
                .then(res => {
                    res.data.map(val => {
                        this.numbers.push({ value: `${val.number}`, text: `${val.number}`});
                    });
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        text: 'جستجوی شماره‌ها با موفقیت انجام شد.'
                    });
                })
        },
        get_users(){
            this.axios.get('users/?type=view_inbox_users')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_badge(status) {
            switch(status) {
                case 'لیست سیاه': return 'danger';
                case 'رد شده': return 'danger';
                case 'در صف ارسال': return 'warning';
                case 'ارسال شده و در انتظار تعیین وضعیت': return 'info';
                case 'تحویل داده نشده': return 'danger';
                case 'تحویل داده شده': return 'success';
                case 'تایید نشده': return 'warning';
                case 'خطا در ارسال': return 'danger';
                case 'ارسال شده به مخابرات': return 'info';
            }
        },
        open_to(route) {
            window.open(`/#${route}`, '_blank').focus()
        },
        download(){
            this.$notify({
                group: 'foo',
                type: 'success',
                text: 'فایل در حال دانلود است. لطفا صبور باشید.'
            });
            this.download_modal = false;
            if(this.disable == false){
                let filter = '';
                for (const key in this.form) {
                    if(this.form[key].val != ''){
                        if (key == 'created_at') {
                            filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                        } else{
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
                this.axios.get('inbox_sms_messages/' 
                    + '?download=1' 
                    + filter, {responseType: 'blob'})
                    .then(res => {
                        const FileSaver = require('file-saver');
                        FileSaver.saveAs(new Blob([res.data], {type : res.headers['content-type']}));
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        },
        get() {
            if (this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'created_at') {
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else{
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('inbox_sms_messages/' 
                    + '?count=1' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('inbox_sms_messages/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + '&user_info=1' 
                        + filter)
                        .then(res => {
                            res.data.map(val =>{
                                val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
                                val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                if(val.sms_text.length > 20){
                                    val.full_sms_text = val.sms_text;
                                    val.short_sms_text = val.full_sms_text.substring(0, 20);
                                    val.short_sms_text += '...';
                                } else {
                                    val.short_sms_text = val.full_sms_text = val.sms_text;
                                } 
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_inbox_sms_message_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
